import React, { useEffect, useState } from "react";
import { Col, Container, Modal } from "react-bootstrap";
import styled from "styled-components";
import {
  ButtonDemo,
  CustomRow,
  Description,
  Error,
  Section,
  SubTitle,
  TitleSection,
} from "../../DesignComponent/DesignComponents";
import { Font } from "../../../theme/Font";
import { Color } from "../../../theme/Color";
import { useHistory } from "react-router-dom";
import { isValidEmail } from "../../../utils/validation";
import axios from "axios";
import newsletter from "../../../assets/NewSite/newsletter.svg";

const NewsLetterPopup = ({
  show,
  handleClose,
  singlepostdata,
  pastDaysCount,
  ipAddress,
  getSpreadsheetData,
}) => {
  const [FullName, setFullName] = useState("");
  const [Email, setEmail] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setNameError("");
    setEmailError("");
    const url =
      "https://staging2.theleansuite.com/wp-json/custom/v1/apollo-newsletter";

    if (!FullName) {
      setNameError("Full Name is required.");
    }

    if (!Email) {
      setEmailError("Email Address is required.");
    } else if (!isValidEmail(Email)) {
      setEmailError("Please enter a valid email address.");
    }

    if (FullName && Email && !nameError && !emailError) {
      const data = {
        name: FullName,
        email: Email,
      };
      const response = await axios.post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      await appendSpreadsheet();
      if (response.status == 200) {
        handleClose();
        // navigate.push("/newsletter-success");
      }
    }
  };

  const appendSpreadsheet = async () => {
    const newRow = {
      IP_Address: ipAddress,
      Full_Name: FullName,
      Email: Email,
      Blog_Title: singlepostdata.title,
    };
    try {
      let response = await axios.post(
        "https://theleansuite.com/api/blog-signup",
        // "https://theleansuite.com/api/add-row",
        newRow
      );
      if (response.status === 200) {
        await getSpreadsheetData();
      }
    } catch (error) {
      console.error("Error adding row:", error);
    }
  };
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="xl"
        style={{ zIndex: 99999, backgroundColor: "rgba(255, 255, 255, 0.5)" }}
      >
        <Modal.Header
          closeButton
          className="border-0 pb-0"
          style={{ backgroundColor: "rgb(248, 245, 241)", fontSize: "12px" }}
        ></Modal.Header>
        <Modal.Body
          className="pt-0 border-0"
          style={{
            color: "#1C1C4B",
            backgroundColor: "rgb(248, 245, 241)",
            borderRadius: "0.5rem",
          }}
        >
          <Section
            className="py-0"
            style={{ backgroundColor: Color.theme_four, minHeight:'unset' }}
          >
            <Container>
              <CustomRow className="justify-content-center align-items-stretch py-3">
                <Col md={5} className="pe-5">
                  <div>
                    <SubTitle className="sub-title mb-2">
                      Sign up for Leansuite's newsletter
                    </SubTitle>
                    <TitleSection className="mb-3">
                      Transform your operations: Join the Leansuite community
                    </TitleSection>
                    <SubTitle className="sub-title mb-2">
                      {pastDaysCount < 6 && singlepostdata.title}
                    </SubTitle>
                    <Description>
                      Experience the power of continuous improvement with
                      LeanSuite. By subscribing to our newsletter, you'll
                      receive weekly content on lean manufacturing practices
                      that can revolutionize your operations.
                    </Description>
                  </div>
                  <form>
                    <div className="mb-3">
                      <Tit
                        className="text-muted mb-"
                        style={{ textAlign: "start", display: "block" }}
                      >
                        Full Name:
                      </Tit>
                      <Input
                        type="text"
                        value={FullName}
                        onChange={(e) => setFullName(e.target.value)}
                      />
                      {nameError && <Error>{nameError}</Error>}
                    </div>
                    <div className="mb-3">
                      <Tit
                        className="text-muted mb-"
                        style={{ textAlign: "start", display: "block" }}
                      >
                        Email Address:
                      </Tit>
                      <Input
                        type="text"
                        value={Email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      {emailError && <Error>{emailError}</Error>}
                    </div>
                  </form>
                  <SmallText className="text-center ">
                  By clicking “Sign-Up” you agree to LeanSuite’s{" "}
                  <a href="/legal/privacy">Privacy Policy</a>.
                </SmallText>
                  <ButtonDemo
                    className="rounded-1 w-100"
                    onClick={(e) => handleSubmit(e)}
                    type="submit"
                  >
                    {"Sign Up"}
                  </ButtonDemo>
                </Col>
                <Col
                  md={5}
                  className="d-flex align-items-center justify-content-center"
                >
                  <ImageContainer className="h-100 w-100 p-4">
                    <img
                      className="h-100 w-100"
                      src={newsletter}
                      alt="theleansuite newsletter"
                    />
                  </ImageContainer>
                </Col>
              </CustomRow>
            </Container>
            {/* ) : ''} */}
          </Section>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NewsLetterPopup;

const Input = styled.input`
  width: 100%;
  // height: 6vh;
  background-color: ${Color.white};
  border: 1px solid lightgrey;
  // margin-top: 8px;
  border-radius: 2px;
  padding: 10px;
  &:focus-visible {
    outline: none;
  }
`;
const SmallText = styled.p`
  font-size: 14px;
  font-family: ${Font.basel};
`;
const ImageContainer = styled.div`
  height: 300px;
  width: 300px;
  object-fit: contain;
`;
const Lasttext = styled.p`
  color: ${Color.text};
  font-family: ${Font.basel};
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 15px;
  letter-spacing: -1%;
  margin-top: 23px;
  align-text: start;
`;
const Tit = styled.label`
  text-align: start;
  justify-content:start
  color: #687C82;
  font-family: ${Font.basel};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  // margin-top:23px;
  text-align: start;
  margin-bottom:5px
`;
